import { checkinApi } from '@/services/api/httpClient';

const actions = {
  async getQuestionnaire({ commit, getters }) {
    const admissionId = getters?.getCurrentAdmissionState?.data?.id;
    const url = `/admission/questions/${admissionId}/unanswered`;
    try {
      const getAdmissionUnansweredQuestions = await checkinApi().get(url);
      const questions = getAdmissionUnansweredQuestions?.data;
      commit('SET_QUESTIONNAIRE', questions);
      return questions;
    } catch (error) {
      return [];
    }
  },
};

export default actions;
